/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  AppointmentListResult,
  GetApiCcofPracticeIdAppointmentsParams,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiCcofPracticeIdAppointmentsResponse200 = {
  data: AppointmentListResult;
  status: 200;
};

export type getApiCcofPracticeIdAppointmentsResponse401 = {
  data: void;
  status: 401;
};

export type getApiCcofPracticeIdAppointmentsResponse403 = {
  data: void;
  status: 403;
};

export type getApiCcofPracticeIdAppointmentsResponseSuccess =
  getApiCcofPracticeIdAppointmentsResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdAppointmentsResponseError = (
  | getApiCcofPracticeIdAppointmentsResponse401
  | getApiCcofPracticeIdAppointmentsResponse403
) & {
  headers: Headers;
};

export const getGetApiCcofPracticeIdAppointmentsUrl = (
  practiceId: string,
  params?: GetApiCcofPracticeIdAppointmentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/ccof/${practiceId}/appointments?${stringifiedParams}`
    : `/api/ccof/${practiceId}/appointments`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Returns appointments between 'from' and 'to' (inclusive), ordered by appointment time. Both params default to today when omitted; omitting 'to' returns a single day. Same-day appointments whose time has already passed are excluded. Pass 'nextToken' from a previous response to fetch the next page. Use 'hasCard=false' to show only patients with no card on file (the 'No Card on File' tab). 'status' selects Active (default — cancelled appointments are hidden), Cancelled, or All; each item carries its own 'status'. The response always includes summary counts (totalCount / noCardCount) for the full date range and status filter, regardless of hasCard — use these to populate tab badge counts.
 * @summary Returns a paged appointment list for a practice within a date range.
 */
export const getApiCcofPracticeIdAppointments = async (
  practiceId: string,
  params?: GetApiCcofPracticeIdAppointmentsParams,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiCcofPracticeIdAppointmentsResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdAppointmentsResponseSuccess>(
    getGetApiCcofPracticeIdAppointmentsUrl(practiceId, params),
    {
      ...options,
      method: "GET",
    },
  );
};
